import React, {useContext, createContext, useState, ReactNode, useEffect} from 'react';
import {IAppState, IClient, Orders} from '../common/types';
import {getClient} from '../api';
import AccessKey, {isLogin} from '../utils/getSetAccessKey';
import {RoutesPaths} from "../environment";
import {useHistory} from "react-router";

const defaultAppState: IAppState = {
  client: [null, () => {
  }],
  orders: [null, () => {
  }],
};


export const AppStateContext = createContext(defaultAppState);

export const AppStateProvider = ({children}: { children: ReactNode }) => {
  const client = useState<IClient | null>(null);
  const orders = useState<Orders | null>(null);
  const history = useHistory();
  useEffect(() => {
    if (client[0] === null && isLogin()) {
      (async () => {
        const result = await getClient();
        if (result instanceof Error) {
          AccessKey.remove();
          history.push(RoutesPaths.Auth);
          return;
        }
        client[1](result);
      })();
    }

  }, []);

  const value: IAppState = {
    client,
    orders,
  };
  return (
    <AppStateContext.Provider value={value}>
      {children}
    </AppStateContext.Provider>
  );
};


export const useAppState = (): IAppState => useContext(AppStateContext);
